import Vue from 'vue';
// var moment = require('jalali-moment');


// Vue.directive('tooltip', {
//     bind: function (el, binding) {
//         el.addEventListener('mouseenter', function () {
//             var $tooltip = document.createElement('div')
//             var $tooltipDimension = el.getBoundingClientRect()
//             $tooltip.setAttribute('class', 'tk-tooltip')
//             $tooltip.setAttribute('id', 'tkTooltip')
//             $tooltip.innerHTML = binding.value
//             $tooltip.style.left = $tooltipDimension.left + ($tooltipDimension.width / 2) + 'px'
//             $tooltip.style.top = $tooltipDimension.top - 30 + 'px'
//             document.body.appendChild($tooltip)
//         })
//         el.addEventListener('mouseleave', function () {
//             var elemToRemove = document.getElementById('tkTooltip')
//             elemToRemove.parentNode.removeChild(elemToRemove)
//         })
//     }
// })

Vue.mixin({
    data: function () {
        return {
            requireRule: v => {
                return v === null || (typeof (v) != 'undefined' && v.length !== 0) || 'فیلد ضروری است'
            },
            MobileRule: v =>{
            console.log(v[0])
                if (v[0] == 0 && v[1] == 9){
                console.log('dscsdcsff')
                    return true;
                }
                else if(v === null || v === ''){
                    return true
                }
                else{
                    return 'شماره موبایل اشتباه است'
                }
            },
            NotZero: v => {
                var num = 0
                for (let i = 0; i < v.split(',').length; i++) {
                    num += Number(v.split(',')[i])
                }
                if (num > 0) return true;
                return 'مقدار 0 مجاز نیست';
            },
            numberRule: v => {
                if (v % 1 === 0)
                    return true
                else if (v % 1 !== 0)
                    return true
                // if (typeof v === 'undefined' || v === null || v === '') return true;
                // //if (!v.trim()) return true;
                // if (!isNaN(v) && !isNaN(parseInt(v))) return true;
                else
                    return 'فیلد عددی';
            },
            get basePathUpload() {
                return process.env.VUE_APP_BASEURL + "/files/upload/";
            },
            notificationList: [],
        }
    },
    methods: {
        limitRule(count) {
            return v => v === null || (typeof (v) != 'undefined' && (v.length === 0 || v.length === count)) || `تعداد ${count} کاراکتر مجاز`

        },
        minRule(count) {
            return v => v === null || (typeof (v) != 'undefined' && (v.length === 0 || v.length > count)) || `حداقل ${count} کاراکتر`
        },
        maxRule(count) {
            return v => v === null || (typeof (v) != 'undefined' && (v.length === 0 || v.length < count)) || `حداکثر ${count} کاراکتر`
        },
        CreateFormData(filters, pageNumber, pageSize, order, isDesc, str , reportExport = false) {
            var formData = {};
            filters.forEach(filter => {
                switch (filter.type) {
                    case 'date': {
                        formData[filter.child.beginName] = this.GetMiladi(filter.child.beginValue) || null
                        formData[filter.child.endName] = this.GetMiladi(filter.child.endValue) || null
                        break;
                    }
                    case 'slider': {
                        formData[filter.beginName] = filter.beginValue
                        formData[filter.endName] = filter.endValue
                        break;
                    }
                    case 'singleDate': {
                        formData[filter.name] = this.GetMiladi(filter.value) || null
                        break;
                    }
                    case 'string': {
                        formData[filter.name] = filter.value
                        break;
                    }
                    case 'StrSearch': {
                        formData[filter.name] = filter.value
                        break;
                    }
                    case 'status':{
                        console.log('سلااااام ب')
                        console.log(filter)
                        if (filter.multiple) {
                            console.log(formData ,'clskmlsdkmc')
                            for (let i = 0; i < filter.value.length; i++) {
                                if (filter.value[i].length > 0)
                                    {
                                        formData[filter.name] = filter.value[i]
                                        console.log(formData)
                                    }
                            }
                        } else {
                            if (filter.value > 0) {
                                formData[filter.name] = filter.value
                                console.log(formData ,'heheheh')
                            }
                        }
                        console.log(formData , 'formdata')
                        break;
                    }
                    case 'dropdown': {
                        if (filter.multiple) {
                            for (let i = 0; i < filter.value.length; i++) {
                                if (filter.value[i].length > 0)
                                    {
                                        formData[filter.name] = filter.value[i]
                                    }
                            }
                        } else {
                            if (filter.value.length > 0) {
                                formData[filter.name] = filter.value
                            }
                        }
                        break;
                    }
                    case 'search': {
                        formData[filter.name] = filter.value
                        break;
                    }
                    case 'bool': {
                        formData[filter.name] = filter.value
                        break;
                    }
                    case 'input': {
                        formData[filter.name] = filter.value
                        break;
                    }
                }
            });
            formData['pageNumber'] = pageNumber
            formData['pageSize'] = pageSize
            var order = this.sortOrder 
            //formData["sortBy"] =  isDesc;
            formData['sortAs'] = order
            console.log(formData)
            return formData;
        },
        SumRow(arr) {
            return arr.reduce((a, b) => a + b, 0)
        },
        ClearFilter(filters) {
            filters.forEach(filter => {
                switch (filter.type) {
                    case 'date': {
                        filter.child.beginValue = '';
                        filter.child.endValue = '';
                        break;
                    }
                    case 'string': {
                        filter.value = '';
                        break;
                    }
                    case 'StrSearch' : {
                        filter.value = '';
                        break;
                    }
                    case 'dropdown': {
                        filter.value = '';
                        break;
                    }
                    case 'slider': {
                        filter.beginValue = '';
                        filter.endValue = '';
                        break;
                    }
                    case 'search': {
                        filter.value = '';
                        break;
                    }
                    case 'status': {
                        filter.value = '';
                        break;
                    }
                    case 'bool': {
                        filter.value = false;
                        break;
                    }
                    case 'input': {
                        filter.value = '';
                        break;
                    }

                }
            });
            return filters;
        },
        Success() {
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'موفق',
                text: "درخواست شما انجام شد"
            });
        },
        async getUsers() {
            var response = await this.request({
                method: 'get',
                url: 'home/userslist',
            });
            if (response && response.isSuccess) {
                return response.data.map(element => {
                    return {
                        id: element.value,
                        text: element.text
                    };
                });
            } else return [];
        },
        GetProfile(id) {
            if (!id)
                return '';
            return process.env.VUE_APP_Base_Url + "/files/profiles/" + id + ".jpg";
        },
        // GenerateSmallText(txt) {
        //     if (!txt)
        //         return '';
        //     var reg = /(?<!\p{L}\p{M}*)\p{L}\p{M}*/gu;
        //     var initials = txt.match(reg) || [];
        //     initials = ((initials.shift() || '') + ' ' + (initials.pop() || '')).toUpperCase();
        //     return initials;
        // },
        GenerateColor(txt) {
            var colors = ['purple', 'primary', 'green', 'red', 'pink', 'orange', 'blue', 'indigo', 'teal', 'brown', 'blue-grey', 'lime'];
            if (!txt)
                return '';
            var firstChar = txt.charAt(0);
            var asc = firstChar.charCodeAt(0);
            var OldMin = asc < 200 ? 65 : 1570,
                OldMax = asc < 200 ? 122 : 1740,
                NewMax = 12,
                NewMin = 1;
            var newIndex = Math.round((((asc - OldMin) * (NewMax - NewMin)) / (OldMax - OldMin)) + NewMin);
            return '' + colors[newIndex - 1];
        },
        imageExists(image_url) {
            try {
                if (image_url.length === 0)
                    return false;
                var http = new XMLHttpRequest();
                http.open('HEAD', image_url, false);
                http.send();
                return http.status != 404;
            } catch (x) {
                return false;
            }
        },
    }
})
